let regex = new RegExp(/^(?!.*\.\.)(?!\.)(?!.*\.$)[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*\.[A-Za-z]{2,63}$/);

export default {
    validate(value) {
        return regex.test(value);
    }
};
